import * as angular from 'angular';
import { WorkspaceLoaderService } from './workspace-loader.service';
import { WorkspaceLoader } from './WorkspaceLoader';
import { WorkspaceConfig } from './WorkspaceConfig';

export const workspaceLoaderModule = angular
	.module('mx.sb.WorkSpaceLoader', [])
	.service('mx.sb.WorkSpaceLoader.Service', WorkspaceLoaderService)
	.service('mx.sb.WorkSpaceLoader.Loader', WorkspaceLoader)
	.service('mx.sb.WorkSpaceLoader.Config', WorkspaceConfig);
